import { render, staticRenderFns } from "./OfflineNotifier.component.vue?vue&type=template&id=2829c76a&scoped=true&"
import script from "./OfflineNotifier.component.vue?vue&type=script&lang=js&"
export * from "./OfflineNotifier.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2829c76a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
